import React, { useEffect, useReducer } from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { saveConfigurationNow } from '../store/actions/configuration';
import debounce from 'lodash/debounce';

const lsWardrobesConfigs = reactLocalStorage.getObject('wardrobesConfigs', []);
const initialState = [];

const reducer = (info, newInfo) => {
  if (newInfo === null) {
    reactLocalStorage.removeItem('wardrobesConfigs');
    return initialState;
  }
  return [...newInfo];
};

export const WardrobesConfigsContext = React.createContext();

const saveConfiguration = debounce(saveConfigurationNow, 3000);

export const WardrobesConfigsProvider = ({ children }) => {
  const [wardrobesConfigs, setWardrobesConfigs] = useReducer(
    reducer,
    lsWardrobesConfigs || initialState,
  );

  useEffect(() => {
    saveConfiguration(undefined, wardrobesConfigs);
    reactLocalStorage.setObject('wardrobesConfigs', wardrobesConfigs);
  }, [wardrobesConfigs]);

  return (
    <WardrobesConfigsContext.Provider value={{ wardrobesConfigs, setWardrobesConfigs }}>
      {children}
    </WardrobesConfigsContext.Provider>
  );
};
